// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tag-list-item {
  min-width: 45px;
  height: 24px;
  opacity: 1;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 10px;
  font-size: 13px;
  margin-top: 2px;
  font-weight: 500;
  flex-shrink: 0;
  white-space: nowrap;
  padding-left: 10px;
  padding-right: 10px;
}

.tag-title {
  font-size: 15px;
  line-height: 31px;
  opacity: 1;
  margin-left: 5px;
  font-weight: 500;
  min-width: 31px;
}
.tag-container {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  margin: 0px 10px;
  overflow-x: auto;
  overflow-y: hidden;
  width: max-content;
  min-width: calc(100% - 20px);
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

.tag-container:hover {
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

.tag-container::-webkit-scrollbar {
  height: 4px;
}

.tag-container::-webkit-scrollbar-track {
  background: transparent;
}

.tag-container::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 2px;
}

.tag-container:hover::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
}

.tag-container:hover::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.2);
}

.note-tag-container {
  display: flex;
  flex-direction: column;
  overflow: visible;
}
.tag-dropdown-icon {
  float: right;
  margin-left: 10px;
  position: relative;
  top: 2px;
  line-height: 30px;
  cursor: pointer;
  transition: transform 0.1s ease;
}
.note-tag-show-icon {
  transform-origin: center center;
  display: inline-block;
  transition: transform 0.1s ease;
  margin: 5px;
}
#newTag {
  width: 100%;
  border: none;
  border-radius: 10px;
  height: 100%;
  padding-left: 10px;
}
#newTag:focus {
  outline: none;
}
.tag-list-item-new {
  width: 20px;
  height: 20px;
  opacity: 1;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-right: 10px;
  font-size: 10px;
  margin-top: 7px;
  position: relative;
  bottom: 1px;
  box-sizing: border-box;
  flex-shrink: 0;
}
.icon-add {
  font-weight: bold;
}
.delete-tag-container {
  position: relative;
  left: 30px;
  bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/noteTag/noteTag.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,+BAA+B;EAC/B,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd","sourcesContent":[".tag-list-item {\n  min-width: 45px;\n  height: 24px;\n  opacity: 1;\n  border-radius: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin-right: 10px;\n  font-size: 13px;\n  margin-top: 2px;\n  font-weight: 500;\n  flex-shrink: 0;\n  white-space: nowrap;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.tag-title {\n  font-size: 15px;\n  line-height: 31px;\n  opacity: 1;\n  margin-left: 5px;\n  font-weight: 500;\n  min-width: 31px;\n}\n.tag-container {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n  margin: 0px 10px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  width: max-content;\n  min-width: calc(100% - 20px);\n  scrollbar-width: thin;\n  scrollbar-color: transparent transparent;\n}\n\n.tag-container:hover {\n  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;\n}\n\n.tag-container::-webkit-scrollbar {\n  height: 4px;\n}\n\n.tag-container::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.tag-container::-webkit-scrollbar-thumb {\n  background: transparent;\n  border-radius: 2px;\n}\n\n.tag-container:hover::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.tag-container:hover::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.note-tag-container {\n  display: flex;\n  flex-direction: column;\n  overflow: visible;\n}\n.tag-dropdown-icon {\n  float: right;\n  margin-left: 10px;\n  position: relative;\n  top: 2px;\n  line-height: 30px;\n  cursor: pointer;\n  transition: transform 0.1s ease;\n}\n.note-tag-show-icon {\n  transform-origin: center center;\n  display: inline-block;\n  transition: transform 0.1s ease;\n  margin: 5px;\n}\n#newTag {\n  width: 100%;\n  border: none;\n  border-radius: 10px;\n  height: 100%;\n  padding-left: 10px;\n}\n#newTag:focus {\n  outline: none;\n}\n.tag-list-item-new {\n  width: 20px;\n  height: 20px;\n  opacity: 1;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  margin-right: 10px;\n  font-size: 10px;\n  margin-top: 7px;\n  position: relative;\n  bottom: 1px;\n  box-sizing: border-box;\n  flex-shrink: 0;\n}\n.icon-add {\n  font-weight: bold;\n}\n.delete-tag-container {\n  position: relative;\n  left: 30px;\n  bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
